import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import ContactModal from "../../components/contact/contact/ContactModal";
import ContactCards from "../../components/contact/contact/ContactCards";

import {
  Box,
  Button,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import "./styles.scss";
import * as XLSX from "xlsx";
import { formatDate } from "../../components/reusableComponent/DateFormat";
import ContactFilterModal from "./ContactFilterModal";
import {
  useContactqueryDownloadQuery,
  useContactqueryQuery,
} from "../../Services/customer/FrontendCustomer";
import { Loader } from "react-bootstrap-typeahead";
import { useLocation, useNavigate } from "react-router-dom";
import { useTelephony } from "../../components/context/TelephonyContext";
import { AUTH_TOKEN, INCOMING_CALL, OUTGOING_CALL } from "../../constants";
import axios from "axios";
import { getCustomerPermission } from "./CustomerPermissions";

const ContactPage = () => {
  const location = useLocation();

  const [isContactModalOpen, setIsContactModalOpen] = useState<boolean>(false);
  const [selectAccount, setSelectAccount] = useState<any>("");
  const [liftingColumn, setLiftingColumn] = useState<any>("name");
  const [downloadButtonClicked, setDownloadButtonClicked] = useState<boolean>(false);
  const [isFilterModalOpen, setFilterIsModalOpen] = useState<boolean>(false);
  const [liftingContactFilterData, setLiftingContactFilterData] = useState<any>(
    {}
  );

  const isSmallScreen = useMediaQuery("(max-width:825px)");
  const [page, setPage] = useState<any>(1);
  const [contactData, setContactData] = useState<any>([]);

  // Separate page sizes with different initial values and localStorage keys
  const [contactPageSize, setContactPageSize] = useState<number>(() => {
    const saved = localStorage.getItem("contactRowsPerPage");
    return saved ? parseInt(saved, 10) : 20;
  });

  const [contactCardLoading, setContactCardLoading] = useState<boolean>(false);
  const [contactDownloadLoading, setContactDownloadLoading] =
    useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<any>(0);
  const [ContactDownloadedData, setContactDownloadedData] = useState<any>([]);
  const [liftingContactLocationData, setLiftingContactLocationData] = useState(
    []
  );

  const navigate = useNavigate();
  const permissions = getCustomerPermission();

  console.log(permissions, "permissions");

  const { setLifitinMobileNumber, liftingMobileNumber } = useTelephony();

  //Contact API
  const mobileNumber = localStorage.getItem("liftingMobileNumber");

  const {
    data,
    isLoading: contactQueryLoading,
    refetch: contactRefetch,
    status,
  } = useContactqueryQuery(
    {
      page: page,
      pageSize: contactPageSize,
      sort: liftingColumn,
      liftingContactFilterData,
    },
    { skip: !!mobileNumber }
  );

  const { data: downloadData, status: downloadStatus } =
    useContactqueryDownloadQuery(
      {
        page: page,
        pageSize: contactPageSize,
        sort: liftingColumn,
        liftingContactFilterData,
        downloadButtonClicked,
      },
      { skip: !downloadButtonClicked }
    );

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  useEffect(() => {
    // Retrieve the saved number from localStorage
    const savedNumber = localStorage.getItem("liftingMobileNumber");
    if (savedNumber) {
      setLifitinMobileNumber(savedNumber);
    }
  }, []);

  const {
    setTelephonyContactLoading,
    storedIncomingCallContactData,
    inboundCount,
  } = useTelephony();

  // Outgoing Call Data
  const gettingUserDataResponse = async () => {
    if (outGoingCall) {
      setTelephonyContactLoading(true);
      try {
        const response = await axios.get(
          `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/customers/contacts/?phone_number__endswith=${liftingMobileNumber}&`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            },
          }
        );
        setTelephonyContactLoading(false);
        setContactData(response?.data);
      } catch (error) {
        setTelephonyContactLoading(false);
        console.error("Error fetching user data:", error);
      }
    }
  };

  // Incoming Call Data
  const incomingCall = localStorage.getItem(INCOMING_CALL) === "true";
  const outGoingCall = localStorage.getItem(OUTGOING_CALL) === "true";

  useEffect(() => {
    if (incomingCall) {
      // Incoming call takes priority
      setContactData(storedIncomingCallContactData);
      setTotalCount(inboundCount || 0);
    } else if (outGoingCall) {
      // Outgoing call is next priority
      gettingUserDataResponse();
    } else if (status === "fulfilled" && data) {
      // Initial data as the fallback
      setContactData(data?.results || []);
      setTotalCount(data?.count || 0);
      setContactCardLoading(false);
    }
  }, [storedIncomingCallContactData, status, data, incomingCall, outGoingCall]);

  //Contact Download API useEffect
  useEffect(() => {
    if (downloadStatus === "pending") {
      setContactDownloadLoading(true);
      setDownloadButtonClicked(true);
    } else if (downloadStatus === "fulfilled" && downloadData) {
      setContactDownloadLoading(false);
      setContactDownloadedData(downloadData);
    }
  }, [downloadData, downloadStatus]);

  useEffect(() => {
    if (
      downloadStatus === "fulfilled" &&
      downloadButtonClicked &&
      ContactDownloadedData?.length >= 0
    ) {
      setDownloadButtonClicked(false);
      setContactDownloadLoading(false);
      downloadContactData();
    }
  }, [
    downloadStatus,
    downloadButtonClicked,
    ContactDownloadedData,
    contactDownloadLoading,
  ]);

  // Contact API
  useEffect(() => {
    if (status === "pending") {
      setContactCardLoading(true);
    } else {
      setContactCardLoading(false);
    }
  }, [status, contactCardLoading]);

  useEffect(() => {
    if (status === "fulfilled" && data) {
      setContactData(data?.results || []);
      setTotalCount(data?.count || 0);
      setContactCardLoading(false);
    }
  }, [data, status]);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeModal = () => {
    setIsContactModalOpen(false);
  };

  const handleContactPageSizeChange = (newPageSize: number) => {
    setContactPageSize(newPageSize);
    setPage(1); // Reset to first page
    // Store in localStorage with contact-specific key
    localStorage.setItem("contactRowsPerPage", newPageSize.toString());
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "725px",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };


  const downloadContactData = async () => {
    setDownloadButtonClicked(true);
    setContactDownloadLoading(true);

    if (ContactDownloadedData && ContactDownloadedData.length > 0) {
      const csvData = ContactDownloadedData.map((user) => ({
        Name: user?.name,
        Email: user?.email,
        Tags: user.tags?.map((tag) => tag.name).join(","),
        "Created date": user.created ? formatDate(user.created) : "",
        "Last interaction date": user?.last_interaction_date
          ? formatDate(user?.last_interaction_date)
          : "",
        Account: user?.account?.name,
      }));

      const worksheet = XLSX.utils.json_to_sheet(csvData);
      const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvOutput], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", "Contact_data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setContactDownloadLoading(false);
      setDownloadButtonClicked(false);
      setContactDownloadedData([]);
    } else {
      setContactDownloadLoading(false);
    }
  };

  const openFilterModal = () => {
    setFilterIsModalOpen(true);
  };

  const closeFilterModal = () => {
    setFilterIsModalOpen(false);
  };

  const customFilterModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: "545px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="custom-style">
      <div id="kt_app_content_container" className="app-container w-100 mx-5">
        <div className="card card-flush">
          <div className="card-header align-items-center py-1 gap-2 gap-md-5">
            <div className="d-flex">
              <button
                className="btn btn-link mb-2"
                onClick={handleBackButtonClick}
              >
                <i
                  className="bi bi-arrow-90deg-left"
                  style={{
                    fontSize: "20px",
                    color: "black",
                    cursor: "pointer",
                  }}
                ></i>{" "}
                {/* Arrow icon */}
              </button>
              <h2 className="p-4">
                Contact
              </h2>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Tooltip title="Download Contact Data">
                  <IconButton
                    disabled={downloadContactData?.length < 0}
                    onClick={() => {
                      setDownloadButtonClicked(true);
                      downloadContactData();
                    }}
                  >
                    {contactDownloadLoading ? (
                      <Loader />
                    ) : (
                      <i
                        className="bi bi bi-download"
                        style={{
                          fontSize: "25px",
                          color: "black",
                        }}
                      ></i>
                    )}
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>

          <div className="card-body" style={{ paddingBottom: "0px" }}>
            <div className="row">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    marginRight: "20px",
                    width: "40%",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="text-hover-primary"
                    onClick={openFilterModal}
                    sx={{
                      height: isSmallScreen ? 35 : 40,
                      width: isSmallScreen ? 140 : "auto",
                      minWidth: isSmallScreen ? "140px" : "150px",
                      border: "1px solid #ccc",
                      display: "flex",
                      gap: "10px",
                      overflow: "hidden",
                      fontSize: isSmallScreen ? "12px" : "14px",
                    }}
                  >
                    <i className="bi bi-filter text-dark fs-2" />
                    <span
                      className=" me-2 text-dark"
                      style={{
                        fontSize: isSmallScreen ? "12px" : "14px",
                        whiteSpace: "nowrap",
                        width: "100%",
                        textTransform: "none",
                      }}
                    >
                      Search filter
                    </span>
                  </Button>
                </div>
                <div>
                  <button
                    className="form-control form-control align-items-center fw-bold"
                    style={{
                      backgroundColor: "#6366f1",
                      borderColor: "#6366f1",
                      color: "#ffffff",
                      height: isSmallScreen ? 35 : 45,
                      fontSize: isSmallScreen ? "12px" : "14px",
                      width: isSmallScreen ? "140px" : "200px",
                    }}
                    onClick={openContactModal}
                  // disabled={!permissions.includes('write')}
                  // style={{width: "100%"}}
                  >
                    <i className={`bi bi-plus-lg me-2 text-white`} />
                    <span className="ms-auto" style={{ fontSize: isSmallScreen ? "12px" : "14px" }}>
                      Contact
                    </span>
                  </button>
                </div>

              </div>

              <Modal
                open={isContactModalOpen}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                BackdropProps={{
                  style: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                <Box sx={{ ...style, position: "absolute" }}>
                  <IconButton
                    aria-label="close"
                    onClick={closeModal}
                    sx={{
                      position: "fixed",
                      top: 16,
                      right: 16,
                      zIndex: 1301,
                      background: "white",
                    }}
                  >
                    <GridCloseIcon />
                  </IconButton>
                  <Typography
                    id="modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ mb: 2 }}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Contact
                  </Typography>

                  <Box>
                    <ContactModal
                      closeModal={closeModal}
                      refetchingData={contactRefetch}
                    />
                  </Box>
                </Box>
              </Modal>

              <ReactModal
                isOpen={isFilterModalOpen}
                onRequestClose={closeFilterModal}
                style={customFilterModalStyles}
                contentLabel="Ticket Filter Modal"
                shouldCloseOnOverlayClick={false}
              >
                <ContactFilterModal
                  closeFilterModal={closeFilterModal}
                  setSelectAccount={setSelectAccount}
                  selectAccount={selectAccount}
                  setLiftingContactFilterData={setLiftingContactFilterData}
                  setPage={setPage}
                  contactDataa={contactData}
                  liftingContactFilterData={liftingContactFilterData}
                  contactCardLoading={contactCardLoading}
                />
              </ReactModal>
            </div>

            <div className="row gap-2" style={{ marginTop: "10px" }}>
              {/* Sticky header */}
              {/* Scrollable content with full available height */}
              {/* <div style={{ overflow: "auto", height: "calc(100vh - 350px)" }}> */}
              <ContactCards
                setPage={setPage}
                page={page}
                contactDataa={contactData}
                refetch={
                  mobileNumber
                    ? gettingUserDataResponse
                    : contactRefetch
                }
                contactCardLoading={contactCardLoading}
                totalCount={totalCount}
                setLiftingContactLocationData={
                  setLiftingContactLocationData
                }
                onPageSizeChange={handleContactPageSizeChange} // Add this if ContactCards supports it
                pageSize={contactPageSize} // Add this if ContactCards supports it
                setLiftingColumn={setLiftingColumn}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;